import { useHistory } from 'react-router'
import React from 'react'

import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

import CandidateRequirements from 'components/EditPost/CandidateRequirements'
import { EditedJobPost } from 'components/EditPost'

export default function EditJobPostCandidateRequirementsPage() {
	const history = useHistory()
	const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

	const [persistedJob, saveJob] = usePersistedState({
		entityName: entities.editedJobPost,
		initialValue: {} as EditedJobPost,
	})
	return (
		<CandidateRequirements
			mode={mode}
			isNextAvailable={false}

			displayCertificates={persistedJob?.position?.text === "Hygienist"}
			initRequirement={persistedJob.requirement}
			isOrtho={persistedJob.isOrtho}
			isRestorative={persistedJob.isRestorative}
			onNext={(
				{
					requirement,
					isOrtho,
					isRestorative
				},
			) => {
				saveJob({
					...persistedJob,
					requirement,
					isOrtho,
					isRestorative,
				})

				return 'postTitleDescription'
			}}
		/>
	)
}
